import React from 'react';
import { TabPanel } from 'react-tabs';
export const Panel = ({ style, children, ...other }) => {
    return (React.createElement(TabPanel, { ...other },
        React.createElement("div", { style: style }, children)));
};
Panel.tabsRole = 'TabPanel';
